import React from 'react';
import { Modal } from '../../../../CommonComponents/OPL/Modal/Modal';
import { ModalHeader } from '../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { HtmlTable } from '../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { formatCurrency } from '../../../../CommonUtils/formatNumber';
import { Policies } from '../../../MoneyGuideProTypes';

interface Props {
  data: Policies;
  onClose(): void;
}

export const InsuranceDetailsDrawer: React.FC<Props> = ({ data, onClose }) => {
  return (
    <Modal isOpen variant="bottom" onRequestClose={onClose} contentLabel="Insurance Policy Details">
      <ModalHeader css="padding-left: 16px">Insurance Policy Details</ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <HtmlTable variant="embedded" columnSpacing="small">
        <table>
          <tbody>
            <tr>
              <td>
                <Text textAlign="left">Description</Text>
              </td>
              <td>
                <Text textAlign="right">{data.description}</Text>
              </td>
            </tr>

            <tr>
              <td>
                <Text textAlign="left">Owner</Text>
              </td>
              <td>
                <Text textAlign="right">{data.owner}</Text>
              </td>
            </tr>

            <tr>
              <td>
                <Text textAlign="left">Insured</Text>
              </td>
              <td>
                <Text textAlign="right">{data.insured}</Text>
              </td>
            </tr>

            {data.beneficiaries?.map(beneficiary => (
              <tr key={beneficiary}>
                <td>
                  <Text textAlign="left">Beneficiary</Text>
                </td>
                <td>
                  <Text textAlign="right">{beneficiary}</Text>
                </td>
              </tr>
            ))}

            <tr>
              <td>
                <Text textAlign="left">Annual Premium</Text>
              </td>
              <td>
                <Text textAlign="right">{formatCurrency(data.annualPremium)}</Text>
              </td>
            </tr>

            <tr>
              <td>
                <Text textAlign="left">Cash Value</Text>
              </td>
              <td>
                <Text textAlign="right">{formatCurrency(data.cashValue)}</Text>
              </td>
            </tr>

            <tr>
              <td>
                <Text textAlign="left">Death Benefit</Text>
              </td>
              <td>
                <Text textAlign="right">{formatCurrency(data.deathBenefit)}</Text>
              </td>
            </tr>

            <tr>
              <td>
                <Text textAlign="left">Premium</Text>
              </td>
              <td>
                <Text textAlign="right">{data.premiumPaid}</Text>
              </td>
            </tr>
          </tbody>
        </table>
      </HtmlTable>
    </Modal>
  );
};
